module.exports = new __parcel__URL__("health_icon_small.1ca36849.png").toString();